import { getMessages } from '../../../../../store/constants';

export const IN_WORK_CARD_TOOLTIP = getMessages().getText('top_bar.in_work_card.tooltip');
